import React from 'react';
import { ContentTemplate, TitleHeader } from 'web-library';
import { useTranslation } from 'react-i18next';
import WithdrawFromExam from '../../modules/withdrawal/WithdrawFromExam';

const Instruction = () => {
  const { t } = useTranslation();

  return (
    <>
      <TitleHeader title={t('withdrawal->>WithdrawFromExam.ExamWithdrawal')} />
      <ContentTemplate>
        <WithdrawFromExam />
      </ContentTemplate>
    </>
  );
};

export default Instruction;
